/* eslint-disable eqeqeq */
/* eslint-disable camelcase */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/no-children-prop */
import React, { FC, useEffect, useState } from 'react';
import { Container, CssBaseline, Grid, Typography } from '@mui/material';
import copy from 'copy-to-clipboard';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import useStyles from '../../../../assets/styles/pages/User';
import Header from '../../../../components/Header';
import { ItypeReturnApi } from '../../../../helpers/utils/TypeReturnApi';
import { api } from '../../../../services';
import { useSignInContext } from '../../../../providers/use-signin';
import FooterMenuMain from '../../../../components/FooterMenuMain';

import imgIndicationWin from '../../../../assets/images/tela_indique_ganhe.png';
import { ReactComponent as IconCopy } from '../../../../assets/images/svg/utils/copy.svg';

import {
  FormatPrice,
  FormatPriceInput,
} from '../../../../helpers/utils/Formating';
import ModalListCenter from '../../../../components/Modal/ListCenter';
import ModalConfirmFooter from '../../../../components/Modal/ConfirmFooter';
import { getStorege } from '../../../../helpers/db_storage';

type IndicationWinProps = {
  dsCodIndicacao: string;
  dsLink: string;
  flgAtivo: string;
  vlIndica: string;
  vlIndicaPorcentagem: string;
  vlIndicado: string;
};

const IndicateWin: FC = () => {
  const classeStyle = useStyles();
  const navigate = useNavigate();
  const signData = useSignInContext();

  const [dataConfigIndicationWin, setDataConfigIndicationWin] =
    useState<IndicationWinProps>({} as IndicationWinProps);

  const [dataListShop, setDataListShop] = useState<any>([]);
  const [dataListPaymentFromat, setDataListPaymentFromat] = useState<any>([]);

  const [openModalListPaymentFormat, setOpenModalListPaymentFormat] =
    useState(false);
  const [openModalCopyCodeAndLink, setOpenModalCopyCodeAndLink] =
    useState(false);
  const [openModalListShop, setOpenModalListShop] = useState(false);
  const [openModalNotice, setOpenModalNotice] = useState(false);
  const [noUseIndicationWin, setNoUseIndicationWin] = useState(false);
  const [msgnModalNotice, setMsgModalNotice] = useState({
    title: 'Atenção',
    messagem: '',
  });

  const [dataStorageCity, setDataStorageCity] = useState<any>('');

  const handleToPage = (url: string, replace = false): void => {
    return navigate(url, { replace });
  };

  const handleCloseModalNotice = (): void => {
    setOpenModalNotice(false);
    setNoUseIndicationWin(false);
    if (!dataConfigIndicationWin?.dsCodIndicacao) {
      handleToPage('/dashboard/user', true);
    }
  };

  const getConfigIndicationWin = async (): Promise<void> => {
    try {
      const result: ItypeReturnApi = await api.apiMaisdelivery.auth.cashBack({
        nr_operacao: 63,
        idMarketplace: dataStorageCity?.idMarketplace,
        idUsuario: signData.data?.user?.idUsuario,
      });

      if (result.data.retorno === 'NOK') {
        setMsgModalNotice({
          title: 'Atenção',
          messagem: result.data.mensagem,
        });
        setOpenModalNotice(true);
        setNoUseIndicationWin(true);
        return;
      }

      setDataConfigIndicationWin(result.data[0]);
    } catch (error) {
      toast.error('Ocorreu um erro, tente novamente mais tarde');
    }
  };

  const handleListShop = async (): Promise<void> => {
    try {
      const result: ItypeReturnApi = await api.apiMaisdelivery.auth.cashBack({
        nr_operacao: 61,
        idMarketplace: dataStorageCity?.idMarketplace,
        idUsuario: signData.data?.user?.idUsuario,
      });

      setDataListShop(result.data);
      setOpenModalListShop(true);
    } catch (error) {
      toast.error('Não foi possível buscar os estabelecimentos');
    }
  };

  const handleListPaymentFormat = async (): Promise<void> => {
    try {
      const result: ItypeReturnApi = await api.apiMaisdelivery.auth.cashBack({
        nr_operacao: 62,
        idMarketplace: dataStorageCity?.idMarketplace,
        idUsuario: signData.data?.user?.idUsuario,
      });

      setDataListPaymentFromat(result.data);
      setOpenModalListPaymentFormat(true);
    } catch (error) {
      toast.error('Não foi possível buscar as formas de pagamento');
    }
  };

  const copyToClipboard = (copyTextKeyPix: string): void => {
    setOpenModalCopyCodeAndLink(false);
    copy(copyTextKeyPix);
    setMsgModalNotice({
      title: 'Atenção',
      messagem: 'Mensagem copiada!',
    });
    setOpenModalNotice(true);
  };

  useEffect(() => {
    const dataUserStorage = getStorege('@mais/delivery/user');

    if (!dataUserStorage?.idUsuario) {
      toast.info(
        'Você precisa está logado para acessar o programa de recompensa.',
      );

      handleToPage('/fidelity', true);
    }
  }, []);

  useEffect(() => {
    const dataStorage = JSON.parse(
      localStorage.getItem('@mais/delivery/dataStateCity') as string,
    );
    setDataStorageCity(dataStorage);
  }, []);

  useEffect(() => {
    if (dataStorageCity) {
      getConfigIndicationWin();
    }
  }, [dataStorageCity]);

  useEffect(() => {
    const timerId = setTimeout(() => {
      if (noUseIndicationWin) {
        handleToPage('/dashboard/user', true);
      }
    }, 4000);

    return () => clearTimeout(timerId); // Limpar o setTimeout quando o componente é desmontado
  }, [noUseIndicationWin]);

  return (
    <Container maxWidth={false} className={classeStyle.container}>
      <Header children="Cashback" />
      <CssBaseline />
      {dataConfigIndicationWin?.dsCodIndicacao && (
        <Grid height="100%">
          <Grid
            container
            item
            justifyContent="center"
            alignItems="center"
            textAlign="center"
          >
            <img
              src={imgIndicationWin}
              alt="logo"
              className={classeStyle.imgCashBack}
            />
          </Grid>
          <Grid padding={2}>
            <Typography className={classeStyle.textFontSizeMin}>
              Chame seus amigos para o Mais Delivery e ganhe{' '}
              <b className={classeStyle.textNoBoldBackgroundColor}>
                R$ {FormatPrice(dataConfigIndicationWin.vlIndica)}
              </b>{' '}
              por amigo indicado quando ele fizer seu primeiro pedido! 🤩
            </Typography>
            {dataConfigIndicationWin.vlIndicaPorcentagem != '0.00' && (
              <Typography marginTop={1} className={classeStyle.textFontSizeMin}>
                Você continua ganhando{' '}
                <b className={classeStyle.textNoBoldBackgroundColor}>
                  {FormatPriceInput(
                    dataConfigIndicationWin.vlIndicaPorcentagem,
                  )}
                  %
                </b>{' '}
                sobre tudo que ele pedir! 😱
              </Typography>
            )}
            <Typography marginTop={1} className={classeStyle.textFontSizeMin}>
              Além disso, os seus amigos que se cadastrarem pelo seu link ganham{' '}
              <b className={classeStyle.textNoBoldBackgroundColor}>
                R$ {FormatPrice(dataConfigIndicationWin.vlIndicado)}
              </b>{' '}
              na carteira para gastar no Mais Delivery!
            </Typography>
            <Typography marginTop={1} className={classeStyle.textFontSizeMin}>
              Seu código de indicação é{' '}
              <b className={classeStyle.textNoBoldBackgroundColor}>
                {dataConfigIndicationWin.dsCodIndicacao}
              </b>{' '}
            </Typography>
            <Grid
              container
              item
              xs={12}
              justifyContent="center"
              style={{
                marginTop: 10,
                marginBottom: 10,
                maxWidth: '680px',
                background: '#fff',
              }}
            >
              <Grid
                className={classeStyle.btnCopyCodeAndLink}
                onClick={() => setOpenModalCopyCodeAndLink(true)}
              >
                <Grid>
                  <Typography color="#696969">
                    {' '}
                    Copia Link ou Código de indicação
                  </Typography>
                </Grid>
                <IconCopy />
              </Grid>
            </Grid>
            <Typography
              marginTop={1}
              onClick={handleListShop}
              className={classeStyle.textFontSizeMin}
            >
              Veja aqui os{' '}
              <b className={classeStyle.textNoBoldUnderlined}>
                Estabelecimentos
              </b>{' '}
              participantes.
            </Typography>
            <Typography
              marginTop={1}
              onClick={handleListPaymentFormat}
              className={classeStyle.textFontSizeMin}
            >
              Veja aqui as Formas de{' '}
              <b className={classeStyle.textNoBoldUnderlined}>Pagamento</b>{' '}
              aceitas.
            </Typography>

            <Typography
              marginTop={1}
              onClick={() => handleToPage('/fidelity/extract')}
              className={classeStyle.textFontSizeMin}
            >
              Veja aqui o{' '}
              <b className={classeStyle.textNoBoldUnderlined}>
                Extrato da Conta
              </b>{' '}
              para ver o seu saldo.
            </Typography>
          </Grid>
        </Grid>
      )}
      <ModalConfirmFooter
        isOpen={openModalNotice}
        title={msgnModalNotice.title}
        message={msgnModalNotice.messagem}
        btnNamePrimary="Ok"
        btnNameSecondary=""
        btnCancel=""
        handleFn={async () => handleCloseModalNotice()}
        onClose={() => handleCloseModalNotice()}
        heightModal="400px"
      />

      <ModalConfirmFooter
        isOpen={openModalCopyCodeAndLink}
        title="Atenção"
        message="Deseja copiar o link ou apenas o código de indicação"
        btnNamePrimary="Link"
        btnNameSecondary="Código"
        btnCancel="Cancelar"
        handleFn={async () => copyToClipboard(dataConfigIndicationWin?.dsLink)}
        handleFn2={async () =>
          copyToClipboard(dataConfigIndicationWin?.dsCodIndicacao)
        }
        onClose={() => setOpenModalCopyCodeAndLink(false)}
        heightModal="560px"
      />

      <ModalListCenter
        isOpen={openModalListPaymentFormat}
        title="FORMAS DE PAGAMENTO"
        dataList={dataListPaymentFromat}
        handleFn={async () => setOpenModalListPaymentFormat(false)}
        onClose={() => setOpenModalListPaymentFormat(false)}
      />

      <ModalListCenter
        isOpen={openModalListShop}
        title="ESTABELECIMENTOS"
        dataList={dataListShop}
        handleFn={async () => setOpenModalListShop(false)}
        onClose={() => setOpenModalListShop(false)}
      />
      <FooterMenuMain children="fidelity" />
    </Container>
  );
};

export default IndicateWin;
